import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import jwt_decode from 'jwt-decode'
import { getJWT } from './helpers/cookies.helper'

const jwt = getJWT()
const url = process.env.REACT_APP_TRANSLATIONS_HOST as string

if (jwt === '') {
  window.location.href = process.env.REACT_APP_LOGIN_URL as string
}

let config: {
  lang?: string
  enterprise?: {
    token: string
  }
}

try {
  config = jwt_decode(jwt)
} catch {
  config = {}
}

const { lang: userLang, enterprise } = config

const { token: userEnterprise } = { ...enterprise }

export const languages = ['en', 'es', 'fr', 'pt']

const browserDetector = {
  name: 'reactDetectionNavigator',

  lookup() {
    let found = ''
    if (typeof navigator !== 'undefined') {
      const { browserLanguage = 'es', userLanguage = browserLanguage } =
        navigator as any // IE >= 10
      const { language = userLanguage } = navigator
      const [languageCode] = language.split('-')
      if (!languages.includes(languageCode)) {
        found = 'en'
      }
      found = languageCode
    }

    return 'es'
  },
}

const userDetector = {
  name: 'reactDetectionUser',

  lookup() {
    return 'es' || ''
  },
}

const languageDetector = new LanguageDetector()
languageDetector.addDetector(browserDetector)
languageDetector.addDetector(userDetector)

i18n
  .use(initReactI18next)
  .use(HttpBackend)
  .use(languageDetector)
  .init({
    ns: ['lms'],
    defaultNS: 'lms',
    fallbackNS: 'lms',
    backend: {
      loadPath: `${url}/translations/${config.lang}?token=${userEnterprise}&paths[]=lms`,
      parse: (data: any) => {
        return JSON.parse(data).lms
      },
    },
    detection: {
      order: ['reactDetectionUser', 'reactDetectionNavigator'],
    },
    fallbackLng: languages[0],
    debug: process.env.NODE_ENV === 'development',
    whitelist: languages,
    interpolation: {
      escapeValue: false,
    },
    load: 'languageOnly',
    nonExplicitWhitelist: true,
    react: {
      wait: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'p'],
    },
  })

export default i18n
